import * as React from "react";
import MuiMessageBox from "components/MuiExtras/MessageBox/MuiMessageBox";
import AppMessage, { ISystemMessagesProps } from "components/Translations/AppMessage";

interface ISystemMessageBox extends ISystemMessagesProps {
    message?: string;
    variant?: "error" | "warning" | "info",
}

export const AppMessageBox: React.FC<ISystemMessageBox> = (props) => {
    return (
        <MuiMessageBox
            variant={props.variant || "error"}
            message={props.message ?? <AppMessage resource={props.resource} />}
        />
    );
};